module.exports = __webpack_public_path__ + "img/vip-icon-5.8795a083.png";